export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9016.62beadd8.jpg";